import { HealthPill } from '@/components/system/health-pill';
import { Button } from '@/components/ui/button';
import { useHydrateRole } from '@/hooks/use-hydrate-role';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/store/auth-store';
import { NavLink, Outlet } from 'react-router-dom';

const OPERATOR_NAV = [
  { to: '/dashboard', label: 'Alertas en vivo' },
  { to: '/signals', label: 'Picks del modelo' },
  { to: '/alerts/history', label: 'Historial' },
  { to: '/performance', label: 'Rendimiento' },
  { to: '/settings', label: 'Mi config' },
] as const;

const ADMIN_NAV = [
  { to: '/manual-pick', label: 'Cargar pick' },
  { to: '/reconcile', label: 'Reconciliación' },
  { to: '/admin/operators', label: 'Operadores' },
  { to: '/admin/books', label: 'Casas de apuestas' },
  { to: '/admin/models', label: 'Modelos' },
] as const;

export function AppShell() {
  // Pulls the real role from me.get + keeps it fresh; until the first round-
  // trip resolves the role stays at the optimistic 'operator' default.
  useHydrateRole();
  const role = useAuthStore((state) => state.role);
  const user = useAuthStore((state) => state.user);
  const signOut = useAuthStore((state) => state.signOut);
  const navItems = role === 'admin' ? [...OPERATOR_NAV, ...ADMIN_NAV] : OPERATOR_NAV;

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="sticky top-0 z-50 flex h-14 items-center gap-6 border-b border-border bg-card px-4">
        <div
          className="font-brand text-lg tracking-[0.3em] text-foreground"
          data-testid="app-brand"
        >
          🎾 SCANNER
        </div>
        <nav className="flex items-center gap-1" aria-label="Primary">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground',
                  isActive && 'bg-accent text-foreground',
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-3 text-sm">
          <HealthPill />
          {user ? (
            <span className="font-mono text-muted-foreground" data-testid="user-name">
              {user.name}
            </span>
          ) : null}
          <Button variant="ghost" size="sm" onClick={() => signOut()} data-testid="logout-btn">
            Salir
          </Button>
        </div>
      </header>
      <main className="flex-1 p-6" data-testid="app-main">
        <Outlet />
      </main>
    </div>
  );
}
